import { render, staticRenderFns } from "./icon__spacer--24.vue?vue&type=template&id=35bd42ce"
import script from "./icon__spacer--24.vue?vue&type=script&lang=js"
export * from "./icon__spacer--24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports